import { Stack, Tooltip } from "@introist/react-foundation/v2";
import { UserIdentity } from "../api";
import introistIcon from "../../assets/introist-icon-default.png";
import slackIcon from "../../assets/Icons/slack.svg";

interface UserIdentityIconsProps {
  identities: UserIdentity[];
}

const getIdentityIcon = (system: string) => {
  switch (system) {
    case "introist":
      return introistIcon;
    case "slack":
      return slackIcon;
    default:
      return null;
  }
};

const getIdentityLabel = (identity: UserIdentity) => {
  if (identity.external_name) {
    return identity.external_name ?? identity.external_id;
  }
  return identity.external_system;
};

export const UserIdentityIcons = ({ identities }: UserIdentityIconsProps) => {
  if (identities.length === 0) {
    return null;
  }

  return (
    <Stack gap="small">
      {identities.map(identity => {
        const icon = getIdentityIcon(identity.external_system);
        if (!icon) return null;

        return (
          <Tooltip key={identity.id} tooltip={getIdentityLabel(identity)}>
            <img
              src={icon}
              alt={identity.external_system}
              style={{ width: "16px", height: "16px", borderRadius: "2px" }}
            />
          </Tooltip>
        );
      })}
    </Stack>
  );
};
